exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".SalesByFiscalNumber{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/sales-by-fiscal-number/sales-by-fiscal-number.scss
// module id = 1434
// module chunks = 0